module.exports = __webpack_public_path__ + "img/pdf-icon.641f7880.png";